import { schema } from "normalizr";
import { Summary as SummaryRecord } from "records/payments";

export const Summary = new schema.Entity(
    "paymentsSummary",
    {},
    {
        idAttribute: "key",
    }
);

(Summary as any).record = SummaryRecord;
